module.exports = __webpack_public_path__ + "static/media/small_version.707e9387.svg";